export const MS_PER_SECOND = 1000
export const MS_PER_MINUTE = 60 * MS_PER_SECOND
export const MS_PER_HOUR = 60 * MS_PER_MINUTE

export const TIME = {
    ONE_MINUTE: MS_PER_MINUTE,
    FIVE_MINUTES: 5 * MS_PER_MINUTE,
    TEN_MINUTES: 10 * MS_PER_MINUTE,
} as const
